import { gql } from '@apollo/client'
import { mutate, query } from 'shared/helpers/graphql'

export async function upsertModel(payload) {
  return mutate(
    {
      models: [
        {
          model_type: 'glb',
          ...payload,
        },
      ],
    },
    gql`
      mutation Upsert_models($models: [models_input]) {
        upsert_models(models: $models) {
          id
        }
      }
    `,
  )
}

export async function deleteModel(modelId) {
  return mutate(
    {
      deleteModelsId: modelId,
    },
    gql`
      mutation Delete_models($deleteModelsId: Int!) {
        delete_models(id: $deleteModelsId) {
          id
        }
      }
    `,
  )
}

export async function getModels() {
  return await query(gql`
    query Models {
      models {
        id
        high_res_model_path
        asset {
          display_name
          asset_name
          category {
            id
            category_name
          }
        }
        show_unit_model_in_apartment_page
      }
    }
  `)
}

export async function getModelById(id) {
  return await query({
    query: gql`
      query Models($filters: all_models_filters) {
        models(filters: $filters) {
          low_res_model_path
          high_res_model_path
          bounding_box
          low_res_size_in_bytes
          high_res_size_in_bytes
          initial_gravity_rotation_angle
          scale
        }
      }
    `,
    variables: {
      filters: {
        models: {
          ids: [id],
        },
      },
    },
  })
}
